import React, { useState } from 'react';
import '../styles/MultiFactorModal.css';
import { APIBaseLink } from './APIBaseLink';


function MultiFactorModal({ userId, userEmail, onVerify, onClose }) {
    const [mfaCode, setMfaCode] = useState('');
    const [mfaError, setMfaError] = useState('');
    const [resendMessage, setResendMessage] = useState('');
    const [isResending, setIsResending] = useState(false);
    const API_BASE_LINK = APIBaseLink();

    // Input: User ID and user-submited One Time Pin
    // Output: Checks if submited OTP matches stored OTP doccuemtn in OTPrequests
    // If yes, logs the user in, if not prompts to re-enter code
    const handleMfaSubmit = async () => {
      console.log("Resending MFA code for user:", userId, "Email:", userEmail);
      try {
        const response = await fetch(`${API_BASE_LINK}/user/verify-mfa`, {
          method: 'POST',
          body: JSON.stringify({ userID: userId, otp: mfaCode }), //Match backend key name exactly
          headers: { 'Content-Type': 'application/json' }
        });

        const res = await response.json();
        if (response.ok) {
          onVerify(res.token); //Pass the verified JWT token
        } else {
          setMfaError(res.message || 'Invalid code, please try again.');
        }
      } catch (err) {
        console.log("Error during MFA verification:", err);
        setMfaError('An error occurred while verifying MFA.');
      }
    };

    // Input: Request to resend MFA from button
    // Output: Sends a new OTP to user's email
    const handleMfaResubmit = async () => {
      if (isResending) return; //Prevent multiple clicks

        setIsResending(true);
        setResendMessage('Sending new code...');

        try {
             const response = await fetch(`${API_BASE_LINK}/user/resend-mfa`, {
                method: 'POST',
                body: JSON.stringify({ userID: userId, Email: userEmail }),
                headers: { 'Content-Type': 'application/json' }
            });

            const res = await response.json();
            if (response.ok) {
                setResendMessage(`A new code has been sent to your email.`);
            } else {
                setResendMessage(res.message || 'Failed to resend the code.');
            }
        } catch (err) {
            console.log("Error resending MFA code:", err);
            setResendMessage('An error occurred while resending the code.');
        }

        //Prevent spamming resend requests
        setTimeout(() => setIsResending(false), 30000);
    };

    return (
      <div className="mfa-modal-overlay">
        <div className="modal">
          <div className="mfa-modal-content">
            <h2>Multi-Factor Authentication</h2>
            <p>Enter the code sent to your email:</p>
            <input 
              type="text" 
              value={mfaCode} 
              onChange={(e) => setMfaCode(e.target.value)}
              required
            />
            <div className="resend-container">
              <p onClick={handleMfaResubmit} className={`resend-code ${isResending ? 'disabled' : ''}`}>{isResending ? 'Please wait...' : 'Resend Code'}</p>
                {resendMessage && <p className="resend-message">{resendMessage}</p>}
            </div>
            <div className="mfa-modal-actions">
              <button className="mfa-verify-button" onClick={handleMfaSubmit}>Verify</button>
              <button className="mfa-cancel-button" onClick={onClose}>Cancel</button>
            </div>
            {mfaError && <p className="mfa-error">{mfaError}</p>}
          </div>
        </div>
      </div>
    );
}

export default MultiFactorModal;
